import { render, staticRenderFns } from "./VueAvatar.vue?vue&type=template&id=08ac3e32"
import script from "./VueAvatar.vue?vue&type=script&lang=js"
export * from "./VueAvatar.vue?vue&type=script&lang=js"
import style0 from "./VueAvatar.vue?vue&type=style&index=0&id=08ac3e32&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ac3e32')) {
      api.createRecord('08ac3e32', component.options)
    } else {
      api.reload('08ac3e32', component.options)
    }
    module.hot.accept("./VueAvatar.vue?vue&type=template&id=08ac3e32", function () {
      api.rerender('08ac3e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/vue-avatar/VueAvatar.vue"
export default component.exports